import styled from "@emotion/styled";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

/**
 * Light Table for tabels
 *
 * @example
 *   <LightTable>
 *     <thead>
 *       <tr>
 *         <th>Column 1</th>
 *         <th>
 *          <ColLabel>Column 2</ColLabel>
 *         </th>
 *       </tr>
 *     </thead>
 *     <tbody>
 *       <tr class="selectable selected">
 *         <td>
 *           <div className="selected-mark"></div>
 *           Content 1
 *         </td>
 *       </tr>
 *     </tbody>
 *   </LightTable>
 */
export const LightTable = styled.table`
  position: relative;
  width: 100%;
  table-layout: fixed;

  thead tr:last-child {
    box-shadow: 0 1px 5px 0 ${withVar(DesignToken.SurfacePrimaryDefault)};
  }

  tr {
    border-bottom: solid 1px ${withVar(DesignToken.BorderBasicSecondary)};
  }

  tr.selectable {
    position: relative;
    cursor: pointer;
    transition: background-color 0.25s;

    &:hover {
      background-color: ${withVar(DesignToken.SurfaceSecondaryHover)};
    }
  }

  tr.selected {
    background-color: ${withVar(DesignToken.SurfaceSecondaryDefault)};
  }

  div.selected-mark {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    display: block;
    content: "";
    background-color: ${withVar(DesignToken.ActionPrimaryDefault)};
    width: 0;
    transition: width 0.25s;
  }

  tr.selected div.selected-mark {
    width: 4px;
  }

  th,
  td {
    position: relative;
    vertical-align: middle;
    text-align: left;
  }

  th {
    padding: 0 10px;
    text-transform: uppercase;
  }

  td {
    padding: 10px;
  }

  th {
    height: 35px;
    font-size: 12px;
    font-weight: 400;
    color: ${withVar(DesignToken.ContentBasicSecondary)};
  }
`;
